import { FC, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { SvgIcon } from '../../Icons';

type CreateStepCircleProps = {
  index: number;
  isCompleted?: boolean;
};

const CreateStepCircleComp: FC<CreateStepCircleProps> = ({ index, isCompleted = false }) => {
  return (
    <span
      data-completed={isCompleted}
      className={twMerge(
        'group grid size-6 rounded-full place-items-center border border-secondary-border shrink-0',
        'motion-safe:*:transition-[display,opacity] motion-safe:duration-500 motion-reduce:transition-none transition-discrete *:starting:opacity-0',
        isCompleted ? 'border-success-700 bg-success-700' : ''
      )}
    >
      <SvgIcon name='CheckIcon' className={twMerge('absolute', 'group-data-[completed=false]:hidden group-data-[completed=false]:opacity-0')} />
      <p className={twMerge('absolute text-xs', 'group-data-[completed=true]:hidden group-data-[completed=true]:opacity-0')}>{index + 1}</p>
    </span>
  );
};

export const CreateStepCircle = memo(CreateStepCircleComp);
